;(function () {
  'use strict';

  if (!customElements.get('slideshow-banner')) {
    class SlideshowBanner extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        this.initSwiper();
        window.addEventListener('resize', () => this.initSwiper.call(this)); /* CHECK dit tegen het huidige bestand */
      }
    }

    SlideshowBanner.prototype.initSwiper = function() {
      const { autoplay, delay, pauseOnMouseEnter, loop, speed } = this.dataset; /* CHECK dit tegen het huidige bestand */
      const sliderPauseOnMouseEnter = pauseOnMouseEnter == 'true' ? true : false; /* CHECK dit tegen het huidige bestand */
      const sliderAutoplay = autoplay == 'true' ? {
        delay: +delay,
        disableOnInteraction: false,
        pauseOnMouseEnter: sliderPauseOnMouseEnter
      } : false;

      this.swiper = new Swiper(this, {
        lazy: true,
        keyboard: {
          enabled: true,
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          type: "bullets",
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: sliderAutoplay,
        loop: loop === 'true',
        speed: +speed
      });

      this.swiper.on('slideChange', () => {
        if (this.swiper.pagination) {
          this.swiper.pagination.update();
        }
      });

      // NIEUW - videoslide met 'ended'-event, Jullens 13-09-2026
      this.initVideoSlides(sliderPauseOnMouseEnter);
    };

    // NIEUW - complete methode
    SlideshowBanner.prototype.initVideoSlides = function (pauseOnMouseEnter) {
      const self = this;
      const FALLBACK_MS = 15000; // veiligheidsklep: nooit langer dan 15s vastlopen
      let fallbackTimer = null;

      const getActiveVideo = () => {
        const activeSlide = self.querySelector('.swiper-slide-active');
        return activeSlide ? activeSlide.querySelector('video') : null;
      };

      const getActiveCta = () => {
        const activeSlide = self.querySelector('.swiper-slide-active');
        return activeSlide ? activeSlide.querySelector('.slideshow-banner__video-cta') : null;
      };

      const clearFallback = () => {
        if (fallbackTimer) {
          clearTimeout(fallbackTimer);
          fallbackTimer = null;
        }
      };

      const advanceFromVideo = () => {
        clearFallback();
        if (self.swiper.autoplay) {
          self.swiper.autoplay.start();
        }
        self.swiper.slideNext();
      };

      const handleActiveSlideVideo = () => {
        // Reset en pauzeer alle video's die nu niet actief zijn (incl. loop-duplicaten)
        self.querySelectorAll('.swiper-slide:not(.swiper-slide-active) video').forEach(function (v) {
          v.pause();
          v.currentTime = 0;
        });
        self.querySelectorAll('.swiper-slide:not(.swiper-slide-active) .slideshow-banner__video-cta').forEach(function (cta) {
          cta.classList.remove('is-visible');
        });

        const video = getActiveVideo();
        if (!video) {
          return;
        }

        // Stop Swiper's eigen autoplay-teller voor deze slide; de video bepaalt zelf wanneer door
        if (self.swiper.autoplay && self.swiper.autoplay.running) {
          self.swiper.autoplay.stop();
        }

        video.currentTime = 0;
        clearFallback();

        const cta = getActiveCta();
        let ctaShown = false;

        const onTimeUpdate = () => {
          if (cta && !ctaShown && video.duration && video.currentTime >= video.duration - 2) {
            cta.classList.add('is-visible');
            ctaShown = true;
          }
        };
        video.addEventListener('timeupdate', onTimeUpdate);

        const onEnded = () => {
          video.removeEventListener('timeupdate', onTimeUpdate);
          if (getActiveVideo() === video) {
            advanceFromVideo();
          }
        };
        video.addEventListener('ended', onEnded, { once: true });

        // Veiligheidsklep: als 'ended' om wat voor reden dan ook nooit komt
        fallbackTimer = setTimeout(function () {
          video.removeEventListener('timeupdate', onTimeUpdate);
          if (getActiveVideo() === video) {
            advanceFromVideo();
          }
        }, FALLBACK_MS);

        // Niet afspelen als de bezoeker al met de muis op de slideshow staat
        // en 'stop autoplay on hover' aan staat (respecteert bestaande instelling)
        if (!(pauseOnMouseEnter && self.matches(':hover'))) {
          video.play().catch(function () {});
        }
      };

      this.swiper.on('slideChangeTransitionEnd', handleActiveSlideVideo);

      // Hover-pauze ook laten gelden voor een lopende video
      if (pauseOnMouseEnter) {
        this.addEventListener('mouseenter', function () {
          const video = getActiveVideo();
          if (video && !video.paused && !video.ended) {
            video.pause();
          }
        });
        this.addEventListener('mouseleave', function () {
          const video = getActiveVideo();
          if (video && video.paused && !video.ended) {
            video.play().catch(function () {});
          }
        });
      }

      // Ook direct bij het laden van de pagina checken (als de eerste slide toevallig de video is)
      handleActiveSlideVideo();
    };

    customElements.define('slideshow-banner', SlideshowBanner);
  }
})();

// Jullens versie 2 - 14-09-2026 - videoslide (ended-event) toegevoegd
